import {NgbDateStruct} from "@ng-bootstrap/ng-bootstrap";
import {AbstractFormConfig} from "../abstract-form.config";

export class FormDatepickerConfig extends AbstractFormConfig {

  public minDate: NgbDateStruct | undefined | any = undefined;
  public maxDate: NgbDateStruct | undefined | any = undefined;
  public openOnFocus: boolean = true;
  public background: 'transparent' | undefined;

  constructor(init?: Partial<FormDatepickerConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
